import { tw } from "@careinfo/tailwind";
import TextField from "../../../Reusable/TextField";
import AccountComboboxInput from "../../../Reusable/AccountComboboxInput";
import APIS from "../../../../constant/Endpoint";
import NumberField from "../../../Reusable/NumberField";
import { classNames } from "../../../../utils/classNames";
import PhoneNumberField from "../../../Reusable/PhoneNumberField";

const AccountInfoForm = (props: any) => {
  const {
    control,
    register,
    errors,
    setValue,
    getValues,
    clearErrors,
    isactive,
    setIsActive,
  } = props;

  return (
    <div className={tw`grid grid-cols-2 gap-x-4 px-4`}>
      <TextField label="Ledger Name" control={control} name={"name"} />
      <AccountComboboxInput
        url={APIS.COA}
        queryKey={"ledger-group"}
        register={register("parent")}
        errors={errors?.parent}
        name={"parent"}
        label={"Ledger Group"}
        setValue={setValue}
        props={{
          level__in: "1,2",
          is_group: true,
        }}
        getValues={getValues}
        placeholder={"Search... "}
        clearErrors={clearErrors}
      />
      <div className={tw`flex  gap-x-4`}>
        <NumberField
          value={getValues("opening_balance")}
          register={register("opening_balance")}
          errors={errors?.opening_balance}
          label={"Opening Balance"}
          setValue={setValue}
          clearErrors={clearErrors}
        />
        <div className={tw`flex w-52 h-10  border mt-9 rounded-full`}>
          <button
            onClick={() => setIsActive("credit")}
            type="button"
            className={classNames(
              isactive === "credit" ? tw`bg-primary text-white px-4` : tw``,
              tw`focus:outline-none px-4 py-2 rounded-full`
            )}
          >
            Credit
          </button>
          <button
            onClick={() => setIsActive("debit")}
            type="button"
            className={classNames(
              isactive === "debit" ? tw`bg-primary text-white  px-4` : tw``,
              tw`focus:outline-none px-4 rounded-full  py-2`
            )}
          >
            Debit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountInfoForm;
